import { showSuccessToast } from "./toast";

export function copyToClipboard(text) {
    navigator.clipboard.writeText(text);
    showSuccessToast("Text copied to clipboard.");
}